import { render, staticRenderFns } from "./ParametrizacaoContratoPasso1.vue?vue&type=template&id=1200fe70&lang=html"
import script from "./ParametrizacaoContratoPasso1.vue?vue&type=script&lang=js"
export * from "./ParametrizacaoContratoPasso1.vue?vue&type=script&lang=js"
import style0 from "./ParametrizacaoContratoPasso1.vue?vue&type=style&index=0&id=1200fe70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports